// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER, FLAT_WHITE_FILLER } from '@evolvemep/api-ts';

import polycloudSvg from 'assets/icons/icon-src/markup/polycloud.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class PolycloudTool extends BaseMarkupTool {
  readonly type = 'polycloud'; // Matches the existing type used by Autodesk's polycloud markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 2,
      strokeColor: FLAT_BLACK_FILLER,
      strokeOpacity: 100,
      fillColor: FLAT_WHITE_FILLER,
      fillOpacity: 50,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Polycloud',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
        {
          heading: 'Fill',
          fields: [{ property: 'fill-color', colorLabel: 'Color', opacityLabel: 'Opacity' }],
        },
      ],
    };
  }

  protected activateEditMode() {
    const polycloudEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModePolycloud(this.markupExtension);
    this.markupExtension.changeEditMode(polycloudEditMode);
  }

  protected readonly buttonIcon = polycloudSvg;
  protected readonly buttonTooltip = 'Polycloud';
}
